export default Object.freeze({
  default: 'json',
  blob: 'blob',
});
